export default __webpack_public_path__ + "static/media/string.4cdf9ab1.JPG";